import { getConsultationHistory } from "../../../Common/axios_instance/video_https/video.https";
import { ConsultationHistoryParams } from "../../../Common/axios_instance/video_https/interfaces/video_https.interface";

export const fetchConsultationHistory = (params: ConsultationHistoryParams) =>
  getConsultationHistory(params);
